// components/layout/PageWrapper.tsx
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

const variants = {
  left: {
    initial: { x: "-100%", opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: "100%", opacity: 0 },
  },
  right: {
    initial: { x: "100%", opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: "-100%", opacity: 0 },
  },
};

export default function PageWrapper({ children, direction = "left" }: { children: React.ReactNode; direction?: "left" | "right" }) {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      variants={variants[direction]}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.4 }}
    >
      {children}
    </motion.div>
  );
}
